import { Component } from '@angular/core';

@Component({
  selector: 'app-hl-steps',
  templateUrl: './hl-steps.component.html',
  styleUrls: ['./hl-steps.component.scss'],
  standalone: true,
})
export class HlStepsComponent {}
